import { accountObj, userObj } from '../store'
import { userLevelIsHigerThan } from './users.js'
import { $listLocation } from '@akerolabs/akero-constants/src/constants/locations.js'
export { accountObj } from '../store'

/**
 * Checks to see if the drilled down account is an education edition
 * @returns {boolean}
 */
export function isEducation(account) {
  const session = accountObj(account)
  return session.edition === 'education'
}

export function isStudentPulse(account) {
  const session = accountObj(account)
  return session.studentPulse
}

/**
 *  Returns boolean to for premium accounts!?
 */
export function isPremium(account) {
  const session = accountObj(account)
  return (
    session.planType === 'koala' ||
    session.planType === 'alpaca' ||
    session.planType === 'lemur'
  )
}

/**
 *  Returns boolean for non premium nav view
 */
export function isPremiumNav(account, user) {
  const allowed = ['agencyadmin', 'agencyuser', 'superadmin', 'developer']
  const session = userObj(user)
  const accountData = accountObj(account)

  return (
    accountData.planType === 'koala' ||
    accountData.planType === 'alpaca' ||
    accountData.planType === 'lemur' ||
    allowed.indexOf(session.type) !== -1 ||
    isStudentPulse(accountData)
  )
}

/**
 *  Returns boolean to for lite accounts!?
 */
export function isLite(account) {
  const session = accountObj(account)
  return session.planType === 'platypus' || session.planType === 'armadillo'
}

/**
 *  Checks the type of account community/education/business
 *  @param {String}
 *  @param {Object=} account - optional
 *  @returns {boolean}
 */
export function isType(str, account) {
  const session = accountObj(account)

  try {
    if (str.indexOf(',') === -1) return session.edition.trim() === str
    str = str.split(',').map((i) => i.trim())
    return str.indexOf(session.edition) !== -1
  } catch (e) {
    return false
  }
}

/**
 * Returns boolean for where the current accounts country and region
 * data matches the dashboard region
 */
export function checkCountryRegion(dashboard, account) {
  try {
    if (!dashboard.region || dashboard.region === 'all') return true

    const session = accountObj(account)
    const regionLocation = $listLocation.find((location) => {
      return (
        location.value ===
        (session.contactDetails.address &&
        session.contactDetails.address.country
          ? session.contactDetails.address.country
          : 'gb')
      )
    })

    if (dashboard.region === regionLocation.region) {
      return true
    }
  } catch (ex) {
    /* istanbul ignore next */
  }

  return false
}

export function planAvailable(plan, account) {
  const agencyId =
    account.agency && account.agency._id ? account.agency._id : account.agency

  if (plan.value === 'lemur') {
    // Only show the lemur plan (internal) for those that have it and dev agency
    if (account.planType === 'lemur') return true
    if (agencyId === '52e62a3161e6cb0b00932457') return true
    if (userLevelIsHigerThan('superadmin')) return true
    return false
  }

  if (plan.value === 'platypus' || plan.value === 'armadillo') {
    if (agencyId === '52035c0b01bb5a9b5d130923') return true
    return false
  }

  return true
}
